import React from 'react'
import "../Nagpurprices/Nagpurprice.css"; 
import { Pricecard } from '../Pricecard/Pricecard.jsx';

export default function Nagpurprice() {
  return (
    <>
        <div className="Nagpurprice">
          <div className="container-fluid">
            <div className="container">
                <h1 className='text-center Nagpurprice_title'>PRICING <span className="green">NAGPUR</span></h1>
                <div className="mx-auto border-3 title-border-bottom w-50"></div>
              <div className="row Nagpurprice_Outer pt-4">
                <div className="col-12 col-md-6 Nagpurprice_card g-5">
                    <Pricecard
                        packagesName="Single Session"
                        packagePrice="825/-"
                        pkalistpoint1="Daily Online Payment"
                        pkalistpoint2="Session: Upto 45 Minutes"
                        pkalistpoint3="For Single Session"
                        pkalistpoint4="Alternate Session"
                        packagesLink="/about"
                        pkabuttonText="BOOK NOW"
                        
                    />
                </div>
                <div className="col-12 col-md-6 Nagpurprice_card g-5">
                    <Pricecard
                        packagesName="7 Days Package"
                        packagePrice="5600/-"
                        pkalistpoint1="Advance Online Payment"
                        pkalistpoint2="Session: Upto 45 Minutes"
                        pkalistpoint3="For 7 Session"
                        pkalistpoint4="No Alternate Session"
                        packagesLink="/about"
                        pkabuttonText="BOOK NOW"
                        
                    />
                </div>
                <div className="col-12 col-md-6 Nagpurprice_card g-5">
                    <Pricecard
                        packagesName="15 Days Package"
                        packagePrice="11250/-"
                        pkalistpoint1="Advance Online Payment"
                        pkalistpoint2="Session: Upto 45 Minutes"
                        pkalistpoint3="For 15 Session"
                        pkalistpoint4="No Alternate Session"
                        packagesLink="/about"
                        pkabuttonText="BOOK NOW"
                        
                    />
                </div>
                <div className="col-12 col-md-6 Nagpurprice_card g-5">
                    <Pricecard
                        packagesName="30 Days Package"
                        packagePrice="21000/-"
                        pkalistpoint1="Advance Online Payment"
                        pkalistpoint2="Session: Upto 45 Minutes"
                        pkalistpoint3="For 30 Session"
                        pkalistpoint4="No Alternate Session"
                        packagesLink="/about"
                        pkabuttonText="BOOK NOW"
                        
                    />
                </div>
              </div>
            </div>
          </div>
        </div>
    </>
  )
}
